<div class="proposal-statement">
	<span dcrHTMLKey="PROPOSAL_PURPOSE_PREFIX">This is your </span>
	<span>{{ proposalPortfolioName }}</span>
	<span class="padding-right-5" dcrHTMLKey="PROPOSAL_PURPOSE_RISK_TOLERANCE_PREFIX">, it has an </span>

	<span class="proposal-dropdown paddin-right-5">
		<dz-select
			[class.dropdown-error]="showPurposeValidation && !riskTolerance"
			[placeholder]="'Select Risk Tolerance' | dcr : 'PROPOSAL_PURPOSE_SELECT_RISK_TOLERANCE'"
			[(value)]="riskTolerance"
			(valueChange)="onRiskToleranceChange($event)"
		>
			<dz-option *ngFor="let option of riskToleranceOptions" [value]="option">
				{{ option }}
			</dz-option>
		</dz-select>
		<div *ngIf="showPurposeValidation && !riskTolerance" class="error-message">
			<ng-container *ngTemplateOutlet="errorTemplate"></ng-container>
		</div>
	</span>

	<span dcrHTMLKey="PROPOSAL_RISK_TOLERANCE_SUFFIX"> risk tolerance</span>

	<span class="paddin-right-5" dcrHTMLKey="PROPOSAL_PURPOSE_OBJECTIVE_PREFIX"> with an objective of</span>

	<span class="proposal-dropdown">
		<dz-select
			[class.dropdown-error]="showPurposeValidation && !objective"
			[placeholder]="'Select Objective' | dcr : 'PROPOSAL_PURPOSE_SELECT_OBJECTIVE'"
			[(value)]="objective"
			(valueChange)="onObjectiveChange($event)"
		>
			<dz-option *ngFor="let option of objectiveOptions" [value]="option">
				{{ option }}
			</dz-option>
		</dz-select>
		<div *ngIf="showPurposeValidation && !objective" class="error-message">
			<ng-container *ngTemplateOutlet="errorTemplate"></ng-container>
		</div>
	</span>
</div>

<ng-template #errorTemplate> <icon type="exclamation-circle"></icon> <span class="text-12" dcrHTMLKey="PROPOSAL_DROPDOWN_ERROR">Field cannot be blank</span> </ng-template>
